import { render } from "./App.vue?vue&type=template&id=1de5e6a5"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1de5e6a5&lang=scss"
script.render = render

export default script